export const WarningIcon = ({ className }: { className?: string }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_1904_35540)">
        <path
          d="M31.3351 23.9968L20.0311 3.21706C18.2149 0.159496 13.7876 0.155434 11.9689 3.21706L0.66543 23.9968C-1.19119 27.1211 1.05662 31.0775 4.69556 31.0775H27.3041C30.9399 31.0775 33.1917 27.1243 31.3351 23.9968ZM16 27.3275C14.9664 27.3275 14.125 26.4861 14.125 25.4525C14.125 24.4189 14.9664 23.5775 16 23.5775C17.0336 23.5775 17.875 24.4189 17.875 25.4525C17.875 26.4861 17.0336 27.3275 16 27.3275ZM17.875 19.8275C17.875 20.8611 17.0336 21.7025 16 21.7025C14.9664 21.7025 14.125 20.8611 14.125 19.8275V10.4525C14.125 9.41887 14.9664 8.5775 16 8.5775C17.0336 8.5775 17.875 9.41887 17.875 10.4525V19.8275Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1904_35540">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
